import { render } from "./FiltersBlock.vue?vue&type=template&id=44814278&scoped=true"
import script from "./FiltersBlock.vue?vue&type=script&lang=js"
export * from "./FiltersBlock.vue?vue&type=script&lang=js"

import "./FiltersBlock.vue?vue&type=style&index=0&id=44814278&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44814278"]])

export default __exports__